var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _g, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path18, _path19, _circle19, _path20, _path21, _path22, _g4, _path23, _path24, _circle20, _path25, _path26, _path27, _g5, _path28, _path29, _circle21, _path30, _path31, _path32, _g6, _path33, _path34, _circle22, _path35, _path36, _path37, _g7, _path38, _path39, _circle23, _path40, _path41, _path42, _g8, _path43, _path44, _circle24, _path45, _path46, _path47, _g9, _path48, _path49, _circle25, _path50, _path51, _path52, _g0, _path53, _path54, _circle26, _path55, _path56, _path57, _g1, _g10, _g11, _g12, _g13, _circle27, _circle28, _circle29, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainvisual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2220,
    height: 1156,
    viewBox: "0 0 2220 1156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_405",
    "data-name": "\\u30D1\\u30B9 405",
    d: "M1235.283,185.078a62.468,62.468,0,0,1-26.793,51.327,61.789,61.789,0,0,1-7.306,4.394c-.841.432-1.688.841-2.551,1.229-.776.356-1.558.69-2.351,1.009a62.78,62.78,0,0,1-31.042,4.141q-2.734-.323-5.4-.89l-.232-.049a61.084,61.084,0,0,1-10.865-3.381,62.553,62.553,0,1,1,86.535-57.78Z",
    transform: "translate(-1110.16 -122.515)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_429",
    "data-name": "\\u30D1\\u30B9 429",
    d: "M1780.383,785.123a56.616,56.616,0,0,1-23.89,45.623c-.127.088-.259.181-.391.273s-.278.2-.42.288q-1.232.85-2.512,1.627-1.8,1.1-3.69,2.068c-.039.019-.083.039-.122.059q-1.085.557-2.189,1.055l-.069.029c-.171.078-.352.161-.528.235q-2.046.909-4.174,1.647-1.81.637-3.675,1.143a55.566,55.566,0,0,1-7.746,1.554,56.587,56.587,0,0,1-6.725.459c-.186,0-.371,0-.557,0-1.227,0-2.448-.039-3.656-.117-1.055-.068-2.1-.161-3.138-.288-1.6-.191-3.177-.445-4.73-.777-.068-.01-.137-.025-.205-.039-.053-.01-.112-.024-.166-.034-1.564-.328-3.1-.728-4.614-1.187q-2.133-.646-4.188-1.457c-.351-.137-.7-.273-1.046-.421-.865-.361-1.72-.738-2.561-1.143-.244-.113-.483-.23-.723-.347-.811-.4-1.612-.811-2.395-1.251q-1.415-.785-2.78-1.647-1.723-1.085-3.363-2.292a56.693,56.693,0,1,1,90.253-45.066Z",
    transform: "translate(-1667 -727.808)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_434",
    "data-name": "\\u30D1\\u30B9 434",
    d: "M176.21,809.312a57.579,57.579,0,0,1-24.7,47.309,56.86,56.86,0,0,1-6.734,4.05c-.775.4-1.556.776-2.351,1.133-.716.328-1.437.636-2.167.929a57.865,57.865,0,0,1-28.612,3.817q-2.519-.3-4.975-.82l-.214-.044a56.367,56.367,0,0,1-10.015-3.116,57.657,57.657,0,1,1,79.763-53.258Z",
    transform: "translate(-60.88 -751.646)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_791",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 791",
    transform: "translate(140 106)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_81",
    "data-name": "\\u6955\\u5186\\u5F62 81",
    cx: 202,
    cy: 202,
    r: 202,
    transform: "translate(1676 646)",
    fill: "#f1f1f1",
    opacity: 0.223
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_20",
    "data-name": "\\u6955\\u5186\\u5F62 20",
    cx: 140.5,
    cy: 140.5,
    r: 140.5,
    transform: "translate(-140 536)",
    fill: "#f1f1f1",
    opacity: 0.223
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_21",
    "data-name": "\\u6955\\u5186\\u5F62 21",
    cx: 121.5,
    cy: 121.5,
    r: 121.5,
    transform: "translate(328 726)",
    fill: "#f1f1f1",
    opacity: 0.223
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_23",
    "data-name": "\\u6955\\u5186\\u5F62 23",
    cx: 120.5,
    cy: 120.5,
    r: 120.5,
    transform: "translate(1435 -106)",
    fill: "#f1f1f1",
    opacity: 0.223
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_24",
    "data-name": "\\u6955\\u5186\\u5F62 24",
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(-56 92)",
    fill: "#f1f1f1",
    opacity: 0.223
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_22",
    "data-name": "\\u6955\\u5186\\u5F62 22",
    cx: 102.5,
    cy: 102.5,
    r: 102.5,
    transform: "translate(1799 101)",
    fill: "#f1f1f1",
    opacity: 0.223
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_26",
    "data-name": "\\u6955\\u5186\\u5F62 26",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    transform: "translate(1318 345)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_27",
    "data-name": "\\u6955\\u5186\\u5F62 27",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(1126 266)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_28",
    "data-name": "\\u6955\\u5186\\u5F62 28",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1146 370)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_29",
    "data-name": "\\u6955\\u5186\\u5F62 29",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(950 315)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_30",
    "data-name": "\\u6955\\u5186\\u5F62 30",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(716 135)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_31",
    "data-name": "\\u6955\\u5186\\u5F62 31",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(842 493)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_32",
    "data-name": "\\u6955\\u5186\\u5F62 32",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(786 426)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_33",
    "data-name": "\\u6955\\u5186\\u5F62 33",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(793 487)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_34",
    "data-name": "\\u6955\\u5186\\u5F62 34",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1253 765)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_35",
    "data-name": "\\u6955\\u5186\\u5F62 35",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1195 765)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_36",
    "data-name": "\\u6955\\u5186\\u5F62 36",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1617 750)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_37",
    "data-name": "\\u6955\\u5186\\u5F62 37",
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    transform: "translate(1541 709)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_38",
    "data-name": "\\u6955\\u5186\\u5F62 38",
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    transform: "translate(1724 363)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_39",
    "data-name": "\\u6955\\u5186\\u5F62 39",
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    transform: "translate(753 692)",
    fill: "#f1f1f1",
    opacity: 0.473
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_778",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 778",
    transform: "translate(608.1 17.53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_777",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 777",
    transform: "translate(-18.1 109)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_733",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 733",
    transform: "translate(297.335 284.86)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_298",
    "data-name": "\\u30D1\\u30B9 298",
    d: "M1018.088,712.592q.111-2.311.114-4.648a95.47,95.47,0,0,0-109.221-94.438,69.657,69.657,0,0,0-85.524-32.755A118.612,118.612,0,0,0,654.07,647.38c-2-.108-4.009-.167-6.034-.167a109.893,109.893,0,1,0,0,219.786H743.9l14.434,6.349a11.283,11.283,0,0,0,14.867-5.783l.249-.566H983.5v-.287a80.979,80.979,0,0,0,34.589-154.121ZM705.706,812.185a43.686,43.686,0,0,1-9.179-86.38l98.6-21.214-4.153,9.441-1.453,3.3-11.331,2.438L698.9,736.832a32.4,32.4,0,1,0,13.628,63.344l44.794-9.638-5.606,12.744L714.9,811.2A43.725,43.725,0,0,1,705.706,812.185Zm70.88-65.441-6.238,14.181-36.263,7.8a6.276,6.276,0,0,1-2.64-12.271Zm54.587,54.7-7.457,16.952a1.945,1.945,0,0,1-.276.437c-.027.033-.055.065-.085.1a1.968,1.968,0,0,1-.359.31c-.007,0-.013.011-.02.015a1.967,1.967,0,0,1-.449.2c-.039.013-.079.024-.119.034a1.961,1.961,0,0,1-.45.065c-.016,0-.032,0-.049,0a1.924,1.924,0,0,1-.259-.027c-.042-.006-.085-.005-.128-.014a1.981,1.981,0,0,1-.382-.122l-30.865-13.576-6.982,15.874,19.542,8.6a1.713,1.713,0,0,1,.875,2.25L797.2,847.344a1.7,1.7,0,0,1-.241.382c-.024.029-.049.057-.074.085a1.715,1.715,0,0,1-.313.27c-.006,0-.012.01-.018.014a1.689,1.689,0,0,1-.391.178c-.034.011-.07.021-.105.03a1.725,1.725,0,0,1-.392.057c-.014,0-.029,0-.043,0a1.676,1.676,0,0,1-.222-.023c-.039-.006-.078,0-.117-.013a1.708,1.708,0,0,1-.334-.107l-16.215-7.133-3.326-1.463L764.75,863.849a2.038,2.038,0,0,1-.29.459c-.028.035-.058.069-.089.1a2.043,2.043,0,0,1-.376.325l-.021.016a2.093,2.093,0,0,1-.47.213c-.041.014-.083.025-.125.036a2.069,2.069,0,0,1-.472.068c-.017,0-.034,0-.052,0a2.047,2.047,0,0,1-.274-.028c-.044-.006-.088-.006-.133-.015a2.072,2.072,0,0,1-.4-.128l-21.041-9.255a2.057,2.057,0,0,1-1.052-2.7l22.9-52.057,5.606-12.744,9.937-22.591,3.088-7.022,6.238-14.181,12.936-29.409.419-.952,5.187-11.792,3.686-8.379q-.992-.781-1.948-1.6-1.908-1.635-3.661-3.41a60.546,60.546,0,0,1-12.372-18.264q-.491-1.122-.937-2.264-.892-2.282-1.6-4.632a60.437,60.437,0,0,1-2.151-24.466q.3-2.5.8-4.986a60.744,60.744,0,0,1,3.921-12.3c.378-.859.779-1.7,1.191-2.534.121-.243.245-.483.369-.724q.478-.933.983-1.842c.125-.224.247-.449.374-.67.455-.8.924-1.582,1.411-2.351.045-.07.092-.138.137-.208q.673-1.05,1.385-2.063c.151-.216.3-.428.457-.641q.612-.849,1.249-1.672c.139-.179.275-.361.415-.539q.839-1.058,1.716-2.075c.083-.1.171-.189.255-.284q.766-.871,1.562-1.708c.174-.184.35-.364.525-.546q.745-.764,1.513-1.5c.14-.133.275-.269.416-.4q.976-.915,1.986-1.784c.118-.1.239-.2.358-.3q.846-.715,1.716-1.4.29-.226.582-.45.875-.668,1.771-1.3c.128-.09.252-.184.381-.274q1.091-.76,2.212-1.469c.151-.1.306-.188.459-.282q.907-.564,1.832-1.094c.209-.12.419-.24.629-.357q1-.559,2.022-1.08c.1-.053.207-.11.312-.162q1.181-.593,2.387-1.131c.186-.084.375-.163.561-.244q.948-.414,1.91-.8c.224-.089.449-.179.675-.265.753-.288,1.51-.564,2.273-.822.066-.022.132-.048.2-.07.831-.278,1.67-.533,2.513-.776.221-.063.443-.121.665-.183q.97-.266,1.95-.5c.209-.05.417-.1.627-.149l.087-.021q2.557-.58,5.165-.938c.247-.034.5-.064.744-.095q.986-.122,1.976-.213c.245-.022.49-.047.736-.066.872-.069,1.747-.124,2.624-.155.082,0,.163,0,.245,0,.764-.024,1.53-.029,2.3-.024.537,0,1.074.023,1.612.041.464.016.928.028,1.392.054.546.031,1.092.08,1.638.125.458.039.915.072,1.372.121.556.06,1.112.139,1.668.214.447.061.9.115,1.343.186.569.09,1.138.2,1.706.31.434.082.869.155,1.3.247.584.124,1.167.27,1.75.412.417.1.834.192,1.25.3.609.162,1.214.349,1.821.531.388.116.778.221,1.164.344.664.214,1.324.455,1.985.693.326.118.654.221.98.345q1.447.549,2.879,1.177l.057.024q2.42,1.064,4.7,2.311a60.18,60.18,0,0,1,22.114,20.775c.3.477.58.967.867,1.452a60.9,60.9,0,0,1,4.357,8.92q1.052,2.706,1.845,5.507t1.313,5.667a60.24,60.24,0,0,1-4.163,35.137q-.516,1.171-1.077,2.307c-.12.245-.247.484-.369.726-.26.513-.523,1.022-.8,1.525-.151.277-.3.55-.458.823q-.391.7-.8,1.379c-.163.272-.326.543-.493.812-.287.462-.58.917-.877,1.369-.159.242-.316.485-.477.724q-.546.8-1.116,1.584c-.1.141-.2.288-.307.429q-.731.989-1.5,1.941c-.128.159-.261.312-.391.47s-.256.3-.383.454c-.265.318-.528.636-.8.946-.188.214-.379.424-.569.635q-.535.594-1.082,1.173-.31.327-.625.648-.551.564-1.118,1.112c-.206.2-.411.4-.62.6-.422.4-.852.787-1.284,1.171-.167.149-.331.3-.5.449q-.913.794-1.853,1.552c-.046.037-.093.071-.14.107q-.867.691-1.759,1.349c-.2.148-.4.29-.606.435-.449.323-.9.641-1.356.951-.235.159-.473.316-.711.473q-.654.431-1.32.845c-.244.151-.487.3-.732.45-.077.046-.154.089-.231.135-.391.233-.783.463-1.179.687-.221.125-.44.254-.663.376q-.916.5-1.848.975c-.086.043-.169.09-.255.133q-1.07.535-2.162,1.027c-.191.087-.384.166-.576.25-.535.235-1.072.465-1.614.685-.256.1-.514.2-.771.3q-.731.285-1.468.552-.41.148-.824.29c-.493.17-.989.332-1.486.489-.265.083-.53.169-.8.25-.563.169-1.128.326-1.695.48-.2.054-.4.112-.6.164q-1.154.3-2.321.553c-.138.03-.279.054-.417.083-.636.133-1.275.259-1.916.372-.268.047-.538.088-.807.132-.52.084-1.04.164-1.561.235-.3.04-.595.077-.893.113q-.756.092-1.516.163c-.3.029-.6.057-.9.081-.535.043-1.07.075-1.607.1-.265.014-.528.032-.794.043q-1.1.045-2.2.049c-.068,0-.135,0-.2,0l-.137,0c-.938,0-1.878-.03-2.819-.076-.31-.015-.621-.04-.932-.06q-1.033-.066-2.066-.167-.5-.05-1-.108l-.037,0q-1.038-.121-2.077-.282c-.307-.046-.614-.088-.921-.14-.987-.166-1.974-.35-2.959-.567l-1.109,2.521-2.617,5.949-10.319,23.461L814.17,751.5l-13.026,29.613-1.839,4.18,11.836,5.206,19.029,8.37A1.96,1.96,0,0,1,831.172,801.441Zm37.748-61.725L834.7,747.079l-9.394,2.022,6.238-14.181,3.1-.667,31.638-6.807a6.276,6.276,0,0,1,2.64,12.271ZM927.241,752.4a43.367,43.367,0,0,1-27.463,19.027L834.87,785.39l-8.337,1.794-15.065-6.626.811-1.845,22.539-4.849L897.4,760.4a32.4,32.4,0,0,0-1.858-63.672,69.71,69.71,0,0,0,8.356-9.569,44.139,44.139,0,0,1,10.359,4.919A43.52,43.52,0,0,1,927.241,752.4Z",
    transform: "translate(-538.142 -566.239)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_299",
    "data-name": "\\u30D1\\u30B9 299",
    d: "M1048.786,674.116l-8.038-11.357-33.235,23.522-3.918-10.925-13.1,4.7,10.1,28.171Z",
    transform: "translate(-708.68 -602.627)",
    fill: "#224ea8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_300",
    "data-name": "\\u30D1\\u30B9 300",
    d: "M1037.217,938.672l-18.33,31.741,46.681-9.463Z",
    transform: "translate(-422.048 -421.786)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_739",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 739",
    transform: "translate(406.271 437.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_736",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 736",
    transform: "translate(0 49.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_735",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 735"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_301",
    "data-name": "\\u30D1\\u30B9 301",
    d: "M873.153,1056.945a10.1,10.1,0,0,0-11.184-10.1,9.793,9.793,0,0,0-1.327.245L826.47,1017.8l2.042-11.007-16.843-5.458-5.078,17.639a10.23,10.23,0,0,0,4.34,11.418l42.038,26.588a9.539,9.539,0,0,0,.052.99,10.1,10.1,0,0,0,12.259,8.761,9.909,9.909,0,0,0,1.19-.343A10.128,10.128,0,0,0,873.153,1056.945Z",
    transform: "translate(-748.137 -931.933)",
    fill: "#f2d1c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_302",
    "data-name": "\\u30D1\\u30B9 302",
    d: "M770.36,1145.123h44.059c0,1.267,45.409,2.295,45.409,2.295a11.812,11.812,0,0,1,1.936,1.835,11.392,11.392,0,0,1,2.661,7.342v1.835a11.476,11.476,0,0,1-11.471,11.471H770.36a11.481,11.481,0,0,1-11.471-11.471v-1.836A11.487,11.487,0,0,1,770.36,1145.123Z",
    transform: "translate(-730.3 -986.14)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_489",
    "data-name": "\\u9577\\u65B9\\u5F62 489",
    width: 11.93,
    height: 77.088,
    transform: "translate(76.056 183.306)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_303",
    "data-name": "\\u30D1\\u30B9 303",
    d: "M859.863,1301.641c0,1.443-18.078.558-40.379.558s-40.38.885-40.38-.558,18.079-12.889,40.38-12.889S859.863,1300.2,859.863,1301.641Z",
    transform: "translate(-737.921 -1040.288)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_304",
    "data-name": "\\u30D1\\u30B9 304",
    d: "M891.445,1275.067H902.7l5.353-29.181H891.443Z",
    transform: "translate(-780.273 -1024.127)",
    fill: "#9f616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_305",
    "data-name": "\\u30D1\\u30B9 305",
    d: "M886.84,1301.408h36.278v-.459a14.121,14.121,0,0,0-14.12-14.12H886.839Z",
    transform: "translate(-778.537 -1039.562)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_306",
    "data-name": "\\u30D1\\u30B9 306",
    d: "M870.175,1200.868l22.429-50.3a18.432,18.432,0,0,0-8.093-23.662l-48.651-26.089-22.2-1.888-20.478-1.862-.148.25c-.189.32-4.592,7.924-1.616,16.263,2.258,6.326,8.13,11.266,17.454,14.685,21.763,7.98,46.9,14.8,56.7,17.362a3.165,3.165,0,0,1,2.029,1.615,3.212,3.212,0,0,1,.18,2.569l-20.838,46.817a4.131,4.131,0,0,0,3.5,5.534l15.57,1.133c.132.013.264.019.4.019A4.127,4.127,0,0,0,870.175,1200.868Z",
    transform: "translate(-742.175 -968.023)",
    fill: "#cbcbcb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_307",
    "data-name": "\\u30D1\\u30B9 307",
    d: "M879.66,1275.067h11.25l5.353-29.181H879.659Z",
    transform: "translate(-775.83 -1024.127)",
    fill: "#9f616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_308",
    "data-name": "\\u30D1\\u30B9 308",
    d: "M875.055,1301.408h36.277v-.459a14.121,14.121,0,0,0-14.12-14.12H875.054Z",
    transform: "translate(-774.094 -1039.562)",
    fill: "#2f2e41"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_309",
    "data-name": "\\u30D1\\u30B9 309",
    d: "M859.694,1205.438l22.43-50.3a18.433,18.433,0,0,0-8.093-23.662l-48.651-26.089-22.2-1.888-16.04-1.391,0-.22c-.189.319-4.592,7.924-1.615,16.263,2.258,6.325,3.541,11.266,12.866,14.685,21.763,7.98,46.9,14.8,56.7,17.362a3.168,3.168,0,0,1,2.03,1.615,3.212,3.212,0,0,1,.18,2.569L836.465,1201.2a4.13,4.13,0,0,0,3.5,5.533l15.571,1.134q.2.018.394.019A4.127,4.127,0,0,0,859.694,1205.438Z",
    transform: "translate(-739.954 -969.841)",
    fill: "#cbcbcb"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_310",
    "data-name": "\\u30D1\\u30B9 310",
    d: "M812.122,1056.8c1.075-.761,16.519,7.342,19.272.918-12.848-32.12-3.995-45.99-11.865-64.41a22.936,22.936,0,0,0-15.2-13.013l-20.419-1.031-.106.051a23.866,23.866,0,0,0-13.049,25.319c.072,20.046,12.066,35.335,7.872,49.874a4.7,4.7,0,0,0,.444,3.655,4.483,4.483,0,0,0,2.86,2.12l26.961-3.6a4.558,4.558,0,0,0,3.686-.713Z",
    transform: "translate(-734.652 -923.61)",
    fill: "#2f2e41"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_734",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 734",
    transform: "translate(26.737)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_82",
    "data-name": "\\u6955\\u5186\\u5F62 82",
    cx: 22.54,
    cy: 22.54,
    r: 22.54,
    transform: "translate(6.793 6.901)",
    fill: "#f2d1c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_311",
    "data-name": "\\u30D1\\u30B9 311",
    d: "M776.2,940.121c1.2.524,3.65-9.019,2.551-10.927-1.634-2.838-1.537-2.818-2.622-4.7s-1.327-4.448.077-6.1,4.655-1.434,5.3.638c-.412-3.935,3.48-7.1,7.335-7.987s7.923-.337,11.8-1.128c4.5-.918,9.18-4.689,7.385-9.637a6.973,6.973,0,0,0-1.359-2.234c-2.074-2.332-4.975-3.327-7.811-4.29-5.9-2-11.963-4.031-18.192-3.81a26.429,26.429,0,0,0-23.352,17.078,23.981,23.981,0,0,0-.994,3.694c-2.138,11.494,4.537,22.831,15.378,27.208Z",
    transform: "translate(-755.916 -889.934)",
    fill: "#2f2e41"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_312",
    "data-name": "\\u30D1\\u30B9 312",
    d: "M968.846,1021.751l2.585,15.348a.947.947,0,0,1-.054.508L951.1,1088.276a.945.945,0,0,1-1.821-.312l-.859-20.362a.957.957,0,0,1,.068-.4l18.553-45.655a.945.945,0,0,1,1.807.2Z",
    transform: "translate(-801.752 -939.332)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_313",
    "data-name": "\\u30D1\\u30B9 313",
    d: "M968.087,1024.12l2.456,13.185-18,46.237-2.336-14.874Z",
    transform: "translate(-802.428 -940.522)",
    fill: "#224ea8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_314",
    "data-name": "\\u30D1\\u30B9 314",
    d: "M852.518,1113.037c.443,1.729,58.574,3.6,59.177,3.077a12.274,12.274,0,0,0,1.4-2.164c.609-1.088,1.173-2.179,1.173-2.179l-.956-18.384-57.263-6.12s-2.534,15.342-3.329,22.39A16.953,16.953,0,0,0,852.518,1113.037Z",
    transform: "translate(-765.593 -964.328)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_315",
    "data-name": "\\u30D1\\u30B9 315",
    d: "M922.758,1099.171l.005,15.839-25.327-1.8,1.121-15.759Z",
    transform: "translate(-782.532 -968.167)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_316",
    "data-name": "\\u30D1\\u30B9 316",
    d: "M875.959,1103.987l.153-.019-1.2,6.733-14.071-1,.48-6.754Z",
    transform: "translate(-768.738 -970.239)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_317",
    "data-name": "\\u30D1\\u30B9 317",
    d: "M852.518,1126.586c.443,1.729,58.574,3.6,59.177,3.077a12.274,12.274,0,0,0,1.4-2.164l-60.375-4.293A16.953,16.953,0,0,0,852.518,1126.586Z",
    transform: "translate(-765.593 -977.877)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_318",
    "data-name": "\\u30D1\\u30B9 318",
    d: "M809.046,1067.374l49.036,9.151a9.6,9.6,0,0,0,.415.9,10.118,10.118,0,0,0,6.494,5.071,10.095,10.095,0,1,0-2.3-18.719,9.837,9.837,0,0,0-1.141.719l-42.591-14.549-2.18-10.98-17.667,1.169,1.83,18.407A10.042,10.042,0,0,0,809.046,1067.374Z",
    transform: "translate(-745.462 -946.119)",
    fill: "#f2d1c9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_319",
    "data-name": "\\u30D1\\u30B9 319",
    d: "M798,1034.349l25.671-8.437-5.988-17.194a10.25,10.25,0,0,0-11.364-6.739h0a10.25,10.25,0,0,0-8.564,10.224Z",
    transform: "translate(-744.951 -932.121)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_320",
    "data-name": "\\u30D1\\u30B9 320",
    d: "M928.893,1310.99H713.565a.565.565,0,1,1,0-1.13H928.893a.565.565,0,1,1,0,1.13Z",
    transform: "translate(-713 -1048.246)",
    fill: "#cbcbcb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_321",
    "data-name": "\\u30D1\\u30B9 321",
    d: "M806.967,967v11.837H790.388l.677-10.533Z",
    transform: "translate(-742.175 -918.988)",
    fill: "#f2d1c9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_322",
    "data-name": "\\u30D1\\u30B9 322",
    d: "M790.388,984.879s.381,3.115,8.48,4.361c0,0,7.476.623,8.722.623s7.969,2.642,3.673-2.728S798.106,982.387,790.388,984.879Z",
    transform: "translate(-742.175 -925.029)",
    fill: "#f2d1c9"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_738",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 738",
    transform: "translate(194.688)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_83",
    "data-name": "\\u6955\\u5186\\u5F62 83",
    cx: 58.874,
    cy: 58.874,
    r: 58.874,
    fill: "#fff",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_737",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 737",
    transform: "translate(23.54 41.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_323",
    "data-name": "\\u30D1\\u30B9 323",
    d: "M1067.612,904.461a9.115,9.115,0,0,1,7.082-10.754l14.657-3.018-.834-4.054-14.657,3.018A13.243,13.243,0,1,0,1079.2,915.6l14.657-3.018-.834-4.054-14.657,3.018A9.115,9.115,0,0,1,1067.612,904.461Z",
    transform: "translate(-1063.285 -880.284)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_324",
    "data-name": "\\u30D1\\u30B9 324",
    d: "M1142.3,876.714l-14.657,3.018.834,4.053,14.657-3.018a9.1,9.1,0,0,1,3.672,17.835l-14.657,3.018.835,4.054,14.657-3.018a13.243,13.243,0,0,0-5.341-25.942Z",
    transform: "translate(-1087.548 -876.44)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_325",
    "data-name": "\\u30D1\\u30B9 325",
    d: "M1126.14,899.92a1.6,1.6,0,0,0,1.242-1.886h0a1.6,1.6,0,0,0-1.885-1.242l-9.749,2.007-14.864,3.061-9.749,2.007a1.6,1.6,0,1,0,.644,3.127l9.748-2.007,14.864-3.06Z",
    transform: "translate(-1073.304 -884.101)",
    fill: "#3f3d56"
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_80",
    "data-name": "\\u7DDA 80",
    x1: 125.846,
    y2: 110.271,
    transform: "translate(749.544 259.791)",
    fill: "none",
    stroke: "#224ea8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 17,
    opacity: 0.31
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_81",
    "data-name": "\\u7DDA 81",
    x1: 172.982,
    y2: 33.441,
    transform: "translate(800.842 455.413)",
    fill: "none",
    stroke: "#224ea8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 17,
    opacity: 0.31
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_82",
    "data-name": "\\u7DDA 82",
    x1: 44.856,
    y2: 150.766,
    transform: "translate(651.11 166.341)",
    fill: "none",
    stroke: "#224ea8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 17,
    opacity: 0.31
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_83",
    "data-name": "\\u7DDA 83",
    x2: 21.946,
    y2: 189.749,
    transform: "translate(483.19 115.736)",
    fill: "none",
    stroke: "#224ea8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 17,
    opacity: 0.31
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_84",
    "data-name": "\\u7DDA 84",
    x2: 85.597,
    y2: 137.299,
    transform: "translate(304.099 234.248)",
    fill: "none",
    stroke: "#224ea8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 17,
    opacity: 0.31
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_85",
    "data-name": "\\u7DDA 85",
    x2: 170.115,
    y2: 11.204,
    transform: "translate(146.48 466.004)",
    fill: "none",
    stroke: "#224ea8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 17,
    opacity: 0.31
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_86",
    "data-name": "\\u7DDA 86",
    y1: 93.667,
    x2: 97.909,
    transform: "translate(261.112 562.352)",
    fill: "none",
    stroke: "#224ea8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 17,
    opacity: 0.31
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_87",
    "data-name": "\\u7DDA 87",
    x1: 62.729,
    y1: 85.271,
    transform: "translate(768.428 570.748)",
    fill: "none",
    stroke: "#224ea8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7,
    strokeDasharray: 17,
    opacity: 0.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_742",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 742",
    transform: "translate(782.35 276.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_740",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 740",
    transform: "translate(0 2.466)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_326",
    "data-name": "\\u30D1\\u30B9 326",
    d: "M1347.581,622.143a12.1,12.1,0,0,1-2.993-.388l-.193-.053-.179-.09a49.6,49.6,0,0,1-16.2-12.72,48.148,48.148,0,0,1-8.181-14.528,55.913,55.913,0,0,1-3.162-19.7c0-.141.005-.249.005-.324a7.757,7.757,0,0,1,4.608-7.284c2.142-.892,21.591-8.881,23-9.458a7.468,7.468,0,0,1,5.922-.026c1.014.414,18.994,7.768,22.879,9.619a8.28,8.28,0,0,1,5.073,7.056,57.457,57.457,0,0,1-4.016,21.674,50.186,50.186,0,0,1-9.019,14.535c-7.362,8.285-14.727,11.223-14.8,11.248A8.05,8.05,0,0,1,1347.581,622.143Zm-1.732-4.29a6.406,6.406,0,0,0,3.066.008,41.113,41.113,0,0,0,13.141-10.122c7.958-8.956,12-20.214,12-33.461-.014-.268-.2-2.183-2.74-3.39-3.81-1.814-22.5-9.456-22.687-9.533l-.052-.022a3.384,3.384,0,0,0-2.5-.06l-.172.08c-.208.085-20.854,8.565-23.056,9.483a3.674,3.674,0,0,0-2.089,3.506c0,.093,0,.229-.006.4C1320.584,583.811,1322.681,606.115,1345.849,617.853Z",
    transform: "translate(-1316.657 -556.958)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_327",
    "data-name": "\\u30D1\\u30B9 327",
    d: "M1346.37,560.7s-20.833,8.556-23.065,9.486a5.685,5.685,0,0,0-3.348,5.395c0,2.232-1.675,31.359,26.413,45.442a8.671,8.671,0,0,0,4.484,0c1.934-.705,26.487-12.61,26.487-45.534,0,0,0-3.349-3.906-5.209s-22.792-9.579-22.792-9.579A5.49,5.49,0,0,0,1346.37,560.7Z",
    transform: "translate(-1317.894 -558.198)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_328",
    "data-name": "\\u30D1\\u30B9 328",
    d: "M1353.34,571.725v45.646s-21.02-10.118-20.833-36.718Z",
    transform: "translate(-1322.632 -562.525)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_84",
    "data-name": "\\u6955\\u5186\\u5F62 84",
    cx: 10.903,
    cy: 10.903,
    r: 10.903,
    transform: "translate(37.594)",
    fill: "#f98043"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_329",
    "data-name": "\\u30D1\\u30B9 329",
    d: "M1397.274,566.066l-1.646-2.326-6.809,4.819-.8-2.238-2.683.962,2.069,5.771Z",
    transform: "translate(-1342.548 -557.049)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_330",
    "data-name": "\\u30D1\\u30B9 330",
    d: "M1381.953,608.245a.723.723,0,0,1,.721.721h0a.723.723,0,0,1-.721.721h-4.495v3.39h6.758a4.111,4.111,0,0,0,0-8.223h-6.758v3.391Z",
    transform: "translate(-1339.579 -572.549)",
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_331",
    "data-name": "\\u30D1\\u30B9 331",
    d: "M1355.386,609.687a.721.721,0,1,1,0-1.442h4.494v-3.391h-6.758a4.111,4.111,0,0,0,0,8.223h6.758v-3.39Z",
    transform: "translate(-1328.854 -572.549)",
    fill: "none"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_741",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 741",
    transform: "translate(15.158 25.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_332",
    "data-name": "\\u30D1\\u30B9 332",
    d: "M1343.089,611.466a4.116,4.116,0,0,1,2.516-5.242l6.375-2.24-.62-1.764-6.376,2.24a5.98,5.98,0,0,0,3.965,11.284l6.376-2.24-.619-1.764-6.376,2.24A4.116,4.116,0,0,1,1343.089,611.466Z",
    transform: "translate(-1340.987 -597.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_333",
    "data-name": "\\u30D1\\u30B9 333",
    d: "M1374.393,594.773l-6.376,2.24.619,1.763,6.376-2.24a4.112,4.112,0,0,1,2.726,7.758l-6.376,2.24.619,1.763,6.376-2.24a5.98,5.98,0,0,0-3.965-11.284Z",
    transform: "translate(-1351.177 -594.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_334",
    "data-name": "\\u30D1\\u30B9 334",
    d: "M1368.764,605.483a.723.723,0,0,0,.441-.92h0a.723.723,0,0,0-.919-.441l-4.241,1.49-6.466,2.271-4.24,1.49a.721.721,0,0,0,.478,1.36l4.241-1.49,6.466-2.272Z",
    transform: "translate(-1345.463 -598.072)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_745",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 745",
    transform: "translate(640.988 202.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_743",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 743",
    transform: "translate(0 2.466)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_335",
    "data-name": "\\u30D1\\u30B9 335",
    d: "M1120.676,503.338a12.07,12.07,0,0,1-2.993-.387l-.193-.054-.179-.09a49.6,49.6,0,0,1-16.2-12.72,48.154,48.154,0,0,1-8.181-14.528,55.916,55.916,0,0,1-3.162-19.7c0-.141,0-.25,0-.325a7.757,7.757,0,0,1,4.608-7.283c2.142-.893,21.591-8.881,23-9.458a7.465,7.465,0,0,1,5.922-.026c1.014.414,18.993,7.768,22.878,9.619a8.279,8.279,0,0,1,5.073,7.055,57.457,57.457,0,0,1-4.016,21.674,50.193,50.193,0,0,1-9.019,14.535c-7.362,8.285-14.727,11.222-14.8,11.248A8.05,8.05,0,0,1,1120.676,503.338Zm-1.732-4.29a6.4,6.4,0,0,0,3.067.009,41.125,41.125,0,0,0,13.14-10.122c7.958-8.956,12-20.213,12-33.461-.014-.268-.2-2.182-2.74-3.39-3.81-1.814-22.5-9.456-22.687-9.533l-.052-.022a3.388,3.388,0,0,0-2.5-.059l-.172.08c-.208.086-20.854,8.566-23.056,9.483a3.675,3.675,0,0,0-2.089,3.506c0,.093,0,.229-.006.4C1093.679,465.006,1095.776,487.311,1118.944,499.048Z",
    transform: "translate(-1089.752 -438.154)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_336",
    "data-name": "\\u30D1\\u30B9 336",
    d: "M1119.465,441.9s-20.833,8.557-23.065,9.487a5.684,5.684,0,0,0-3.348,5.394c0,2.232-1.675,31.359,26.413,45.442a8.671,8.671,0,0,0,4.484,0c1.934-.705,26.488-12.61,26.488-45.535,0,0,0-3.348-3.906-5.208s-22.792-9.58-22.792-9.58A5.49,5.49,0,0,0,1119.465,441.9Z",
    transform: "translate(-1090.989 -439.393)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_337",
    "data-name": "\\u30D1\\u30B9 337",
    d: "M1126.435,452.92v45.647s-21.019-10.118-20.833-36.718Z",
    transform: "translate(-1095.727 -443.721)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_85",
    "data-name": "\\u6955\\u5186\\u5F62 85",
    cx: 10.903,
    cy: 10.903,
    r: 10.903,
    transform: "translate(37.594)",
    fill: "#f98043"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_338",
    "data-name": "\\u30D1\\u30B9 338",
    d: "M1170.369,447.262l-1.647-2.327-6.808,4.819-.8-2.238-2.683.962,2.069,5.771Z",
    transform: "translate(-1115.643 -438.244)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_339",
    "data-name": "\\u30D1\\u30B9 339",
    d: "M1155.048,489.44a.723.723,0,0,1,.721.721h0a.723.723,0,0,1-.721.721h-4.495v3.391h6.758a4.111,4.111,0,0,0,0-8.223h-6.758v3.39Z",
    transform: "translate(-1112.674 -453.745)",
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_340",
    "data-name": "\\u30D1\\u30B9 340",
    d: "M1128.481,490.882a.721.721,0,0,1,0-1.442h4.494v-3.39h-6.758a4.111,4.111,0,0,0,0,8.223h6.758v-3.391Z",
    transform: "translate(-1101.949 -453.745)",
    fill: "none"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_744",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 744",
    transform: "translate(15.158 25.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_341",
    "data-name": "\\u30D1\\u30B9 341",
    d: "M1116.184,492.661a4.117,4.117,0,0,1,2.516-5.242l6.375-2.24-.62-1.763-6.376,2.24a5.98,5.98,0,0,0,3.965,11.284l6.375-2.24-.619-1.763-6.376,2.24A4.116,4.116,0,0,1,1116.184,492.661Z",
    transform: "translate(-1114.082 -478.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_342",
    "data-name": "\\u30D1\\u30B9 342",
    d: "M1147.488,475.969l-6.376,2.24.619,1.764,6.376-2.24a4.111,4.111,0,0,1,2.726,7.758l-6.376,2.24.619,1.764,6.376-2.24a5.98,5.98,0,0,0-3.965-11.284Z",
    transform: "translate(-1124.272 -475.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_343",
    "data-name": "\\u30D1\\u30B9 343",
    d: "M1141.859,486.678a.723.723,0,0,0,.441-.919h0a.722.722,0,0,0-.919-.441l-4.24,1.49-6.465,2.272-4.241,1.49a.721.721,0,0,0,.478,1.361l4.241-1.49,6.465-2.271Z",
    transform: "translate(-1118.558 -479.267)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_748",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 748",
    transform: "translate(855.3 433.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_746",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 746",
    transform: "translate(0 2.466)"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_344",
    "data-name": "\\u30D1\\u30B9 344",
    d: "M1464.676,874.338a12.073,12.073,0,0,1-2.993-.387l-.193-.054-.179-.09a49.6,49.6,0,0,1-16.2-12.72,48.155,48.155,0,0,1-8.181-14.528,55.915,55.915,0,0,1-3.162-19.7c0-.141.005-.25.005-.325a7.757,7.757,0,0,1,4.608-7.283c2.142-.893,21.591-8.881,23-9.458a7.465,7.465,0,0,1,5.922-.026c1.014.414,18.993,7.768,22.878,9.618a8.279,8.279,0,0,1,5.073,7.056,57.458,57.458,0,0,1-4.016,21.674,50.187,50.187,0,0,1-9.019,14.535c-7.362,8.285-14.727,11.222-14.8,11.248A8.049,8.049,0,0,1,1464.676,874.338Zm-1.732-4.29a6.406,6.406,0,0,0,3.067.009,41.129,41.129,0,0,0,13.14-10.122c7.958-8.956,12-20.213,12-33.461-.014-.268-.2-2.182-2.74-3.39-3.81-1.814-22.5-9.456-22.687-9.533l-.052-.022a3.388,3.388,0,0,0-2.5-.059l-.172.08c-.208.086-20.854,8.566-23.056,9.483a3.675,3.675,0,0,0-2.089,3.506c0,.093,0,.229-.006.4C1437.679,836.006,1439.776,858.311,1462.944,870.048Z",
    transform: "translate(-1433.752 -809.154)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_345",
    "data-name": "\\u30D1\\u30B9 345",
    d: "M1463.465,812.9s-20.833,8.557-23.065,9.487a5.684,5.684,0,0,0-3.348,5.394c0,2.232-1.675,31.359,26.413,45.442a8.67,8.67,0,0,0,4.484,0c1.934-.705,26.487-12.61,26.487-45.535,0,0,0-3.348-3.906-5.208s-22.792-9.58-22.792-9.58A5.49,5.49,0,0,0,1463.465,812.9Z",
    transform: "translate(-1434.989 -810.393)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_346",
    "data-name": "\\u30D1\\u30B9 346",
    d: "M1470.435,823.92v45.647s-21.02-10.118-20.833-36.718Z",
    transform: "translate(-1439.727 -814.721)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_86",
    "data-name": "\\u6955\\u5186\\u5F62 86",
    cx: 10.903,
    cy: 10.903,
    r: 10.903,
    transform: "translate(37.594)",
    fill: "#f98043"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_347",
    "data-name": "\\u30D1\\u30B9 347",
    d: "M1514.369,818.262l-1.647-2.326-6.808,4.819-.8-2.238-2.683.962,2.069,5.771Z",
    transform: "translate(-1459.643 -809.244)",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_348",
    "data-name": "\\u30D1\\u30B9 348",
    d: "M1499.048,860.44a.723.723,0,0,1,.721.721h0a.723.723,0,0,1-.721.721h-4.495v3.391h6.758a4.111,4.111,0,0,0,0-8.223h-6.758v3.39Z",
    transform: "translate(-1456.674 -824.745)",
    fill: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_349",
    "data-name": "\\u30D1\\u30B9 349",
    d: "M1472.481,861.882a.721.721,0,0,1,0-1.442h4.494v-3.39h-6.758a4.111,4.111,0,0,0,0,8.223h6.758v-3.391Z",
    transform: "translate(-1445.95 -824.745)",
    fill: "none"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_747",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 747",
    transform: "translate(15.158 25.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_350",
    "data-name": "\\u30D1\\u30B9 350",
    d: "M1460.184,863.661a4.117,4.117,0,0,1,2.516-5.242l6.375-2.24-.619-1.763-6.376,2.24a5.98,5.98,0,0,0,3.965,11.285l6.375-2.24-.619-1.763-6.376,2.24A4.116,4.116,0,0,1,1460.184,863.661Z",
    transform: "translate(-1458.082 -849.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_351",
    "data-name": "\\u30D1\\u30B9 351",
    d: "M1491.488,846.969l-6.376,2.24.619,1.764,6.376-2.24a4.111,4.111,0,0,1,2.726,7.758l-6.376,2.24.619,1.764,6.376-2.24a5.98,5.98,0,1,0-3.965-11.284Z",
    transform: "translate(-1468.272 -846.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_352",
    "data-name": "\\u30D1\\u30B9 352",
    d: "M1485.859,857.678a.723.723,0,0,0,.441-.919h0a.722.722,0,0,0-.919-.441l-4.24,1.49-6.465,2.272-4.241,1.49a.721.721,0,0,0,.478,1.361l4.241-1.49,6.465-2.271Z",
    transform: "translate(-1462.558 -850.267)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_751",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 751",
    transform: "translate(766.834 583.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_749",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 749",
    transform: "translate(0 2.466)"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_353",
    "data-name": "\\u30D1\\u30B9 353",
    d: "M1322.676,1114.339a12.067,12.067,0,0,1-2.993-.387l-.193-.054-.179-.09a49.6,49.6,0,0,1-16.2-12.72,48.157,48.157,0,0,1-8.181-14.528,55.917,55.917,0,0,1-3.162-19.7c0-.141.005-.25.005-.325a7.757,7.757,0,0,1,4.608-7.283c2.142-.893,21.591-8.882,23-9.458a7.465,7.465,0,0,1,5.922-.026c1.014.414,18.993,7.768,22.878,9.619a8.278,8.278,0,0,1,5.073,7.056,57.455,57.455,0,0,1-4.016,21.673,50.187,50.187,0,0,1-9.019,14.535c-7.362,8.285-14.727,11.222-14.8,11.248A8.05,8.05,0,0,1,1322.676,1114.339Zm-1.732-4.29a6.407,6.407,0,0,0,3.067.009,41.134,41.134,0,0,0,13.14-10.123c7.958-8.956,12-20.213,12-33.461-.014-.269-.2-2.182-2.74-3.39-3.81-1.814-22.5-9.456-22.686-9.533l-.052-.022a3.387,3.387,0,0,0-2.5-.059l-.172.08c-.208.086-20.854,8.566-23.056,9.483a3.675,3.675,0,0,0-2.089,3.506c0,.093,0,.229-.006.4C1295.679,1076.006,1297.776,1098.311,1320.944,1110.048Z",
    transform: "translate(-1291.752 -1049.154)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_354",
    "data-name": "\\u30D1\\u30B9 354",
    d: "M1321.465,1052.9s-20.833,8.557-23.065,9.487a5.684,5.684,0,0,0-3.348,5.394c0,2.232-1.675,31.359,26.413,45.442a8.669,8.669,0,0,0,4.484,0c1.934-.705,26.488-12.61,26.488-45.534,0,0,0-3.348-3.906-5.208s-22.792-9.58-22.792-9.58A5.49,5.49,0,0,0,1321.465,1052.9Z",
    transform: "translate(-1292.989 -1050.393)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_355",
    "data-name": "\\u30D1\\u30B9 355",
    d: "M1328.435,1063.92v45.647s-21.019-10.118-20.833-36.718Z",
    transform: "translate(-1297.727 -1054.721)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_87",
    "data-name": "\\u6955\\u5186\\u5F62 87",
    cx: 10.903,
    cy: 10.903,
    r: 10.903,
    transform: "translate(37.594)",
    fill: "#f98043"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_356",
    "data-name": "\\u30D1\\u30B9 356",
    d: "M1372.369,1058.262l-1.647-2.327-6.808,4.819-.8-2.238-2.683.962,2.069,5.771Z",
    transform: "translate(-1317.643 -1049.244)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_357",
    "data-name": "\\u30D1\\u30B9 357",
    d: "M1357.048,1100.44a.723.723,0,0,1,.721.721h0a.723.723,0,0,1-.721.721h-4.495v3.391h6.758a4.112,4.112,0,0,0,0-8.223h-6.758v3.39Z",
    transform: "translate(-1314.674 -1064.745)",
    fill: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_358",
    "data-name": "\\u30D1\\u30B9 358",
    d: "M1330.481,1101.882a.721.721,0,0,1,0-1.442h4.494v-3.39h-6.758a4.112,4.112,0,0,0,0,8.223h6.758v-3.391Z",
    transform: "translate(-1303.95 -1064.745)",
    fill: "none"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_750",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 750",
    transform: "translate(15.158 25.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_359",
    "data-name": "\\u30D1\\u30B9 359",
    d: "M1318.184,1103.661a4.116,4.116,0,0,1,2.516-5.242l6.375-2.24-.619-1.763-6.376,2.24a5.98,5.98,0,0,0,3.965,11.284l6.375-2.24-.619-1.763-6.376,2.24A4.116,4.116,0,0,1,1318.184,1103.661Z",
    transform: "translate(-1316.082 -1089.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_360",
    "data-name": "\\u30D1\\u30B9 360",
    d: "M1349.488,1086.969l-6.376,2.24.619,1.764,6.376-2.24a4.111,4.111,0,0,1,2.726,7.758l-6.376,2.24.619,1.764,6.376-2.24a5.98,5.98,0,0,0-3.965-11.284Z",
    transform: "translate(-1326.272 -1086.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_361",
    "data-name": "\\u30D1\\u30B9 361",
    d: "M1343.859,1097.678a.723.723,0,0,0,.441-.919h0a.722.722,0,0,0-.919-.441l-4.24,1.49-6.466,2.272-4.241,1.49a.721.721,0,0,0,.478,1.361l4.241-1.49,6.465-2.271Z",
    transform: "translate(-1320.557 -1090.267)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_754",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 754",
    transform: "translate(465.925 175.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_752",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 752",
    transform: "translate(0 2.466)"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_362",
    "data-name": "\\u30D1\\u30B9 362",
    d: "M839.676,459.338a12.068,12.068,0,0,1-2.993-.387l-.193-.054-.179-.09a49.6,49.6,0,0,1-16.2-12.72,48.156,48.156,0,0,1-8.181-14.528,55.916,55.916,0,0,1-3.162-19.7c0-.141.005-.25.005-.325a7.757,7.757,0,0,1,4.608-7.283c2.142-.893,21.591-8.881,23-9.458a7.465,7.465,0,0,1,5.922-.026c1.014.414,18.994,7.768,22.878,9.619a8.279,8.279,0,0,1,5.073,7.055,57.455,57.455,0,0,1-4.016,21.674,50.187,50.187,0,0,1-9.019,14.535c-7.362,8.285-14.726,11.222-14.8,11.248A8.049,8.049,0,0,1,839.676,459.338Zm-1.732-4.29a6.406,6.406,0,0,0,3.067.009,41.126,41.126,0,0,0,13.14-10.122c7.958-8.956,12-20.213,12-33.461-.014-.268-.2-2.182-2.74-3.39-3.81-1.814-22.5-9.456-22.687-9.533l-.052-.022a3.388,3.388,0,0,0-2.5-.059l-.172.08c-.208.086-20.854,8.566-23.056,9.483a3.675,3.675,0,0,0-2.089,3.506c0,.093,0,.229-.006.4C812.679,421.006,814.776,443.311,837.944,455.048Z",
    transform: "translate(-808.752 -394.154)",
    fill: "#3f3d56"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_363",
    "data-name": "\\u30D1\\u30B9 363",
    d: "M838.465,397.9s-20.833,8.557-23.065,9.487a5.684,5.684,0,0,0-3.348,5.394c0,2.232-1.675,31.359,26.413,45.442a8.67,8.67,0,0,0,4.484,0c1.934-.705,26.488-12.61,26.488-45.535,0,0,0-3.348-3.906-5.208s-22.792-9.58-22.792-9.58A5.49,5.49,0,0,0,838.465,397.9Z",
    transform: "translate(-809.989 -395.393)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_364",
    "data-name": "\\u30D1\\u30B9 364",
    d: "M845.435,408.92v45.647s-21.019-10.118-20.833-36.718Z",
    transform: "translate(-814.727 -399.721)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_88",
    "data-name": "\\u6955\\u5186\\u5F62 88",
    cx: 10.903,
    cy: 10.903,
    r: 10.903,
    transform: "translate(37.594)",
    fill: "#f98043"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_365",
    "data-name": "\\u30D1\\u30B9 365",
    d: "M889.369,403.262l-1.647-2.327-6.808,4.819-.8-2.238-2.683.962,2.069,5.771Z",
    transform: "translate(-834.643 -394.244)",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_366",
    "data-name": "\\u30D1\\u30B9 366",
    d: "M874.048,445.44a.723.723,0,0,1,.721.721h0a.723.723,0,0,1-.721.721h-4.495v3.391h6.758a4.111,4.111,0,0,0,0-8.223h-6.758v3.39Z",
    transform: "translate(-831.674 -409.745)",
    fill: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_367",
    "data-name": "\\u30D1\\u30B9 367",
    d: "M847.481,446.882a.721.721,0,0,1,0-1.442h4.494v-3.39h-6.758a4.111,4.111,0,0,0,0,8.223h6.758v-3.391Z",
    transform: "translate(-820.95 -409.745)",
    fill: "none"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_753",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 753",
    transform: "translate(15.158 25.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_368",
    "data-name": "\\u30D1\\u30B9 368",
    d: "M835.184,448.661a4.116,4.116,0,0,1,2.516-5.242l6.375-2.24-.619-1.763-6.376,2.24a5.98,5.98,0,1,0,3.965,11.284l6.375-2.24-.619-1.763-6.376,2.24A4.116,4.116,0,0,1,835.184,448.661Z",
    transform: "translate(-833.082 -434.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_369",
    "data-name": "\\u30D1\\u30B9 369",
    d: "M866.488,431.969l-6.376,2.24.619,1.764,6.376-2.24a4.111,4.111,0,0,1,2.726,7.758l-6.376,2.24.619,1.764,6.376-2.24a5.98,5.98,0,0,0-3.965-11.284Z",
    transform: "translate(-843.273 -431.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_370",
    "data-name": "\\u30D1\\u30B9 370",
    d: "M860.859,442.678a.723.723,0,0,0,.441-.919h0a.722.722,0,0,0-.919-.441l-4.24,1.49-6.466,2.272-4.241,1.49a.721.721,0,0,0,.478,1.361l4.241-1.49,6.466-2.271Z",
    transform: "translate(-837.557 -435.267)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_757",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 757",
    transform: "translate(312.666 264.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_755",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 755",
    transform: "translate(0 2.466)"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_371",
    "data-name": "\\u30D1\\u30B9 371",
    d: "M593.676,603.338a12.075,12.075,0,0,1-2.993-.387l-.193-.054-.179-.09a49.6,49.6,0,0,1-16.2-12.72,48.154,48.154,0,0,1-8.181-14.528,55.91,55.91,0,0,1-3.162-19.7c0-.141,0-.25,0-.325a7.757,7.757,0,0,1,4.608-7.283c2.142-.893,21.591-8.882,23-9.458a7.465,7.465,0,0,1,5.922-.026c1.014.414,18.993,7.768,22.878,9.618a8.279,8.279,0,0,1,5.073,7.055,57.456,57.456,0,0,1-4.016,21.674,50.191,50.191,0,0,1-9.019,14.535c-7.362,8.285-14.727,11.222-14.8,11.248A8.05,8.05,0,0,1,593.676,603.338Zm-1.732-4.29a6.4,6.4,0,0,0,3.067.009,41.125,41.125,0,0,0,13.14-10.122c7.958-8.956,12-20.213,12-33.461-.014-.268-.2-2.182-2.74-3.39-3.81-1.814-22.5-9.456-22.687-9.533l-.052-.022a3.388,3.388,0,0,0-2.5-.059l-.172.08c-.208.086-20.854,8.566-23.056,9.483a3.675,3.675,0,0,0-2.089,3.506c0,.093,0,.229-.006.4C566.679,565.006,568.776,587.311,591.944,599.048Z",
    transform: "translate(-562.752 -538.154)",
    fill: "#3f3d56"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_372",
    "data-name": "\\u30D1\\u30B9 372",
    d: "M592.465,541.9s-20.833,8.557-23.065,9.487a5.684,5.684,0,0,0-3.348,5.394c0,2.232-1.675,31.359,26.413,45.442a8.67,8.67,0,0,0,4.484,0c1.934-.705,26.488-12.61,26.488-45.534,0,0,0-3.348-3.906-5.208s-22.792-9.58-22.792-9.58A5.489,5.489,0,0,0,592.465,541.9Z",
    transform: "translate(-563.989 -539.393)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_373",
    "data-name": "\\u30D1\\u30B9 373",
    d: "M599.435,552.92v45.647s-21.019-10.118-20.833-36.718Z",
    transform: "translate(-568.727 -543.721)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_89",
    "data-name": "\\u6955\\u5186\\u5F62 89",
    cx: 10.903,
    cy: 10.903,
    r: 10.903,
    transform: "translate(37.594)",
    fill: "#f98043"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_374",
    "data-name": "\\u30D1\\u30B9 374",
    d: "M643.369,547.262l-1.647-2.327-6.808,4.819-.8-2.238-2.683.962,2.069,5.771Z",
    transform: "translate(-588.643 -538.244)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_375",
    "data-name": "\\u30D1\\u30B9 375",
    d: "M628.048,589.44a.723.723,0,0,1,.721.721h0a.723.723,0,0,1-.721.721h-4.495v3.391h6.758a4.112,4.112,0,0,0,0-8.223h-6.758v3.39Z",
    transform: "translate(-585.674 -553.745)",
    fill: "none"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_376",
    "data-name": "\\u30D1\\u30B9 376",
    d: "M601.482,590.882a.721.721,0,0,1,0-1.442h4.494v-3.39h-6.758a4.112,4.112,0,0,0,0,8.223h6.758v-3.391Z",
    transform: "translate(-574.95 -553.745)",
    fill: "none"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_756",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 756",
    transform: "translate(15.158 25.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_377",
    "data-name": "\\u30D1\\u30B9 377",
    d: "M589.184,592.661a4.116,4.116,0,0,1,2.516-5.242l6.375-2.24-.619-1.763-6.376,2.24a5.98,5.98,0,0,0,3.965,11.284l6.375-2.24-.619-1.763-6.376,2.24A4.116,4.116,0,0,1,589.184,592.661Z",
    transform: "translate(-587.082 -578.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_378",
    "data-name": "\\u30D1\\u30B9 378",
    d: "M620.488,575.969l-6.376,2.24.619,1.764,6.376-2.24a4.111,4.111,0,0,1,2.726,7.758l-6.376,2.24.619,1.764,6.376-2.24a5.98,5.98,0,0,0-3.965-11.284Z",
    transform: "translate(-597.273 -575.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_379",
    "data-name": "\\u30D1\\u30B9 379",
    d: "M614.859,586.678a.723.723,0,0,0,.441-.919h0a.722.722,0,0,0-.919-.441l-4.24,1.49-6.466,2.272-4.241,1.49a.721.721,0,0,0,.478,1.361l4.241-1.49,6.466-2.271Z",
    transform: "translate(-591.557 -579.267)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_760",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 760",
    transform: "translate(198.034 436.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_758",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 758",
    transform: "translate(0 2.466)"
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_380",
    "data-name": "\\u30D1\\u30B9 380",
    d: "M409.676,878.338a12.069,12.069,0,0,1-2.993-.387l-.193-.054-.179-.09a49.6,49.6,0,0,1-16.2-12.72,48.156,48.156,0,0,1-8.181-14.528,55.911,55.911,0,0,1-3.162-19.7c0-.141,0-.25,0-.325a7.756,7.756,0,0,1,4.608-7.283c2.142-.893,21.591-8.882,23-9.458a7.465,7.465,0,0,1,5.922-.026c1.014.414,18.993,7.768,22.878,9.618a8.279,8.279,0,0,1,5.073,7.055,57.457,57.457,0,0,1-4.017,21.674,50.191,50.191,0,0,1-9.019,14.535c-7.362,8.285-14.727,11.222-14.8,11.248A8.05,8.05,0,0,1,409.676,878.338Zm-1.732-4.29a6.406,6.406,0,0,0,3.067.009,41.125,41.125,0,0,0,13.14-10.122c7.958-8.956,12-20.213,12-33.461-.014-.268-.205-2.182-2.74-3.39-3.81-1.814-22.5-9.456-22.687-9.533l-.052-.022a3.388,3.388,0,0,0-2.5-.059l-.172.08c-.208.086-20.854,8.566-23.056,9.483a3.675,3.675,0,0,0-2.089,3.506c0,.093,0,.229-.006.4C382.679,840.006,384.776,862.311,407.944,874.048Z",
    transform: "translate(-378.752 -813.154)",
    fill: "#3f3d56"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_381",
    "data-name": "\\u30D1\\u30B9 381",
    d: "M408.465,816.9s-20.833,8.557-23.065,9.487a5.684,5.684,0,0,0-3.348,5.394c0,2.232-1.675,31.359,26.413,45.442a8.67,8.67,0,0,0,4.484,0c1.934-.705,26.487-12.61,26.487-45.535,0,0,0-3.348-3.906-5.208s-22.792-9.58-22.792-9.58A5.489,5.489,0,0,0,408.465,816.9Z",
    transform: "translate(-379.989 -814.393)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_382",
    "data-name": "\\u30D1\\u30B9 382",
    d: "M415.435,827.92v45.647s-21.019-10.118-20.833-36.718Z",
    transform: "translate(-384.727 -818.721)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_90",
    "data-name": "\\u6955\\u5186\\u5F62 90",
    cx: 10.903,
    cy: 10.903,
    r: 10.903,
    transform: "translate(37.594)",
    fill: "#f98043"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_383",
    "data-name": "\\u30D1\\u30B9 383",
    d: "M459.369,822.262l-1.647-2.326-6.808,4.819-.8-2.238-2.683.962,2.069,5.771Z",
    transform: "translate(-404.643 -813.244)",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_384",
    "data-name": "\\u30D1\\u30B9 384",
    d: "M444.048,864.44a.723.723,0,0,1,.721.721h0a.723.723,0,0,1-.721.721h-4.495v3.391h6.758a4.112,4.112,0,0,0,0-8.223h-6.758v3.39Z",
    transform: "translate(-401.674 -828.745)",
    fill: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_385",
    "data-name": "\\u30D1\\u30B9 385",
    d: "M417.482,865.882a.721.721,0,0,1,0-1.442h4.494v-3.39h-6.758a4.112,4.112,0,0,0,0,8.223h6.758v-3.391Z",
    transform: "translate(-390.95 -828.745)",
    fill: "none"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_759",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 759",
    transform: "translate(15.158 25.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_386",
    "data-name": "\\u30D1\\u30B9 386",
    d: "M405.184,867.661a4.117,4.117,0,0,1,2.516-5.242l6.375-2.24-.619-1.763-6.376,2.24a5.98,5.98,0,0,0,3.965,11.284l6.375-2.24-.619-1.763-6.376,2.24A4.116,4.116,0,0,1,405.184,867.661Z",
    transform: "translate(-403.082 -853.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_387",
    "data-name": "\\u30D1\\u30B9 387",
    d: "M436.488,850.969l-6.376,2.24.619,1.764,6.376-2.24a4.111,4.111,0,0,1,2.726,7.758l-6.376,2.24.619,1.764,6.376-2.24a5.98,5.98,0,0,0-3.965-11.284Z",
    transform: "translate(-413.273 -850.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_388",
    "data-name": "\\u30D1\\u30B9 388",
    d: "M430.859,861.678a.723.723,0,0,0,.441-.919h0a.722.722,0,0,0-.919-.441l-4.24,1.49-6.466,2.272-4.241,1.49a.721.721,0,0,0,.478,1.361l4.241-1.49,6.466-2.271Z",
    transform: "translate(-407.558 -854.267)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_763",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 763",
    transform: "translate(276.532 577.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_761",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 761",
    transform: "translate(0 2.466)"
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_389",
    "data-name": "\\u30D1\\u30B9 389",
    d: "M535.676,1105.339a12.072,12.072,0,0,1-2.993-.387l-.193-.054-.179-.09a49.6,49.6,0,0,1-16.2-12.72,48.158,48.158,0,0,1-8.181-14.528,55.912,55.912,0,0,1-3.162-19.7c0-.141,0-.25,0-.325a7.757,7.757,0,0,1,4.608-7.283c2.142-.893,21.591-8.882,23-9.458a7.465,7.465,0,0,1,5.922-.026c1.014.414,18.993,7.768,22.878,9.619a8.279,8.279,0,0,1,5.073,7.055,57.456,57.456,0,0,1-4.017,21.674,50.189,50.189,0,0,1-9.019,14.535c-7.362,8.285-14.727,11.222-14.8,11.248A8.051,8.051,0,0,1,535.676,1105.339Zm-1.732-4.29a6.4,6.4,0,0,0,3.067.009,41.127,41.127,0,0,0,13.14-10.122c7.958-8.956,12-20.213,12-33.461-.014-.269-.2-2.182-2.74-3.39-3.81-1.814-22.5-9.456-22.687-9.533l-.052-.022a3.386,3.386,0,0,0-2.5-.059l-.172.08c-.208.086-20.854,8.566-23.056,9.483a3.674,3.674,0,0,0-2.089,3.506c0,.093,0,.229-.006.4C508.679,1067.006,510.776,1089.311,533.944,1101.048Z",
    transform: "translate(-504.752 -1040.154)",
    fill: "#3f3d56"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_390",
    "data-name": "\\u30D1\\u30B9 390",
    d: "M534.465,1043.9s-20.833,8.557-23.065,9.487a5.684,5.684,0,0,0-3.348,5.394c0,2.232-1.675,31.359,26.413,45.442a8.669,8.669,0,0,0,4.484,0c1.934-.705,26.487-12.61,26.487-45.534,0,0,0-3.348-3.906-5.208s-22.792-9.58-22.792-9.58A5.49,5.49,0,0,0,534.465,1043.9Z",
    transform: "translate(-505.989 -1041.393)",
    fill: "#224ea8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_391",
    "data-name": "\\u30D1\\u30B9 391",
    d: "M541.435,1054.92v45.647s-21.019-10.118-20.833-36.718Z",
    transform: "translate(-510.727 -1045.721)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_91",
    "data-name": "\\u6955\\u5186\\u5F62 91",
    cx: 10.903,
    cy: 10.903,
    r: 10.903,
    transform: "translate(37.594)",
    fill: "#f98043"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_392",
    "data-name": "\\u30D1\\u30B9 392",
    d: "M585.369,1049.262l-1.647-2.327-6.808,4.818-.8-2.238-2.683.962,2.069,5.771Z",
    transform: "translate(-530.643 -1040.244)",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_393",
    "data-name": "\\u30D1\\u30B9 393",
    d: "M570.048,1091.44a.723.723,0,0,1,.721.721h0a.723.723,0,0,1-.721.721h-4.495v3.391h6.758a4.112,4.112,0,0,0,0-8.223h-6.758v3.39Z",
    transform: "translate(-527.674 -1055.745)",
    fill: "none"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_394",
    "data-name": "\\u30D1\\u30B9 394",
    d: "M543.482,1092.882a.721.721,0,1,1,0-1.442h4.494v-3.39h-6.758a4.112,4.112,0,0,0,0,8.223h6.758v-3.391Z",
    transform: "translate(-516.95 -1055.745)",
    fill: "none"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_762",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 762",
    transform: "translate(15.158 25.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_395",
    "data-name": "\\u30D1\\u30B9 395",
    d: "M531.184,1094.661a4.116,4.116,0,0,1,2.516-5.242l6.375-2.24-.619-1.763-6.376,2.24a5.98,5.98,0,1,0,3.965,11.284l6.375-2.24-.619-1.763-6.376,2.24A4.116,4.116,0,0,1,531.184,1094.661Z",
    transform: "translate(-529.082 -1080.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_396",
    "data-name": "\\u30D1\\u30B9 396",
    d: "M562.488,1077.969l-6.376,2.24.619,1.764,6.376-2.24a4.111,4.111,0,0,1,2.726,7.758l-6.376,2.24.619,1.764,6.376-2.24a5.98,5.98,0,0,0-3.965-11.284Z",
    transform: "translate(-539.273 -1077.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_397",
    "data-name": "\\u30D1\\u30B9 397",
    d: "M556.859,1088.678a.723.723,0,0,0,.441-.919h0a.722.722,0,0,0-.919-.441l-4.24,1.49-6.466,2.272-4.241,1.49a.721.721,0,0,0,.478,1.361l4.241-1.49,6.466-2.271Z",
    transform: "translate(-533.557 -1081.267)",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_766",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 766",
    transform: "translate(653.702 8.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_765",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 765",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_764",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 764",
    transform: "translate(-9.101 -17.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_398",
    "data-name": "\\u30D1\\u30B9 398",
    d: "M1240.122,166.182a72.176,72.176,0,0,1-30.957,59.3,71.275,71.275,0,0,1-8.442,5.077c-.971.5-1.95.972-2.946,1.42-.9.411-1.8.8-2.717,1.165a72.53,72.53,0,0,1-35.865,4.785q-3.159-.374-6.237-1.028l-.267-.056a70.621,70.621,0,0,1-12.554-3.906,72.276,72.276,0,1,1,99.985-66.761Z",
    transform: "translate(-1095.552 -93.895)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_399",
    "data-name": "\\u30D1\\u30B9 399",
    d: "M1216.255,190.411c-.062-.075-.131-.143-.2-.212a20.836,20.836,0,0,0-29.306-.3c-.043.037-.08.075-.118.112s-.093.087-.138.131a20.828,20.828,0,0,0-6.118,14.753v13.083a2.808,2.808,0,0,0,2.8,2.8h36.134a2.807,2.807,0,0,0,2.8-2.8V204.9A20.774,20.774,0,0,0,1216.255,190.411Z",
    transform: "translate(-1127.531 -127.874)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_92",
    "data-name": "\\u6955\\u5186\\u5F62 92",
    cx: 15.302,
    cy: 15.302,
    r: 15.302,
    transform: "translate(59.253 62.176)",
    fill: "#f9dfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_400",
    "data-name": "\\u30D1\\u30B9 400",
    d: "M1214.757,239a22.721,22.721,0,0,0,2.058,11.214h-13.525s3.342-6.23,2.943-11.214Z",
    transform: "translate(-1136.17 -148.599)",
    fill: "#f9dfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_401",
    "data-name": "\\u30D1\\u30B9 401",
    d: "M1221.26,205.837l-1.807-12.622a1.582,1.582,0,0,0-.554-.991,1.606,1.606,0,0,0-.331-.206,31.6,31.6,0,0,0-27.885-.012,1.522,1.522,0,0,0-.343.218c-.037.031-.074.069-.112.106a1.581,1.581,0,0,0-.437.941l-1.208,12.641a1.562,1.562,0,0,0,.4,1.2,1.539,1.539,0,0,0,.9.486,1.139,1.139,0,0,0,.256.025h3.065a1.572,1.572,0,0,0,1.414-.9l1.327-2.841a.931.931,0,0,1,1.769.28l.262,2.093a1.565,1.565,0,0,0,1.546,1.364h20.2a1.494,1.494,0,0,0,.754-.2,1.586,1.586,0,0,0,.424-.336A1.564,1.564,0,0,0,1221.26,205.837Z",
    transform: "translate(-1130.622 -129.663)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_402",
    "data-name": "\\u30D1\\u30B9 402",
    d: "M1262.916,277.6l4.336,14.516a71.334,71.334,0,0,1-8.442,5.077c-.971.5-1.95.972-2.946,1.42l-4.492-19.257-1.744-7.47,11.214-1.246Z",
    transform: "translate(-1153.638 -160.529)",
    fill: "#f9dfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_403",
    "data-name": "\\u30D1\\u30B9 403",
    d: "M1180.206,277.945l-.374,19.612-.161,8.678a70.619,70.619,0,0,1-12.554-3.906l1.489-18.578.374-4.685Z",
    transform: "translate(-1122.532 -163.282)",
    fill: "#f9dfd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_404",
    "data-name": "\\u30D1\\u30B9 404",
    d: "M1230.965,269.366l-11.265,1.688.138,1.85,1.358,18.64a72.53,72.53,0,0,1-35.865,4.785q-3.159-.374-6.237-1.028c.922-3.875,1.72-7.364.735-8.049a7.524,7.524,0,0,1-.841-.685c-4.591-4.38-2.9-14.267-2.9-14.267l-8.329.461-2.885.162s1.246-19.936,6.853-19.936h6.853l33.019-3.115s9.345-3.115,11.837,1.246c1.309,2.286,3.639,7.133,5.564,11.233,1.744,3.726,3.158,6.834,3.158,6.834Z",
    transform: "translate(-1121.687 -152.292)",
    fill: "#2f2e41"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_767",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 767",
    transform: "translate(196.102 66.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_406",
    "data-name": "\\u30D1\\u30B9 406",
    d: "M520.187,288.2a72.174,72.174,0,0,1-30.454,58.158c-.162.112-.33.23-.5.349s-.355.249-.536.368q-1.57,1.084-3.2,2.075-2.3,1.4-4.7,2.635c-.049.025-.106.05-.156.075q-1.382.71-2.79,1.346l-.087.037c-.218.1-.449.206-.673.3-1.738.773-3.514,1.477-5.32,2.1q-2.308.813-4.685,1.458a70.868,70.868,0,0,1-9.875,1.981,71.98,71.98,0,0,1-8.572.586c-.237.006-.473.006-.71.006-1.564,0-3.121-.05-4.66-.15-1.346-.087-2.679-.206-4-.368-2.037-.243-4.05-.567-6.031-.991-.087-.012-.174-.031-.262-.05-.069-.012-.143-.031-.212-.044-1.994-.417-3.956-.928-5.881-1.514q-2.719-.822-5.339-1.857c-.449-.174-.891-.349-1.334-.536-1.1-.461-2.192-.941-3.264-1.458-.312-.143-.617-.293-.922-.442-1.034-.5-2.056-1.034-3.053-1.595q-1.8-1-3.545-2.1c-1.464-.922-2.9-1.894-4.286-2.922A72.269,72.269,0,1,1,520.187,288.2Z",
    transform: "translate(-375.65 -215.14)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_407",
    "data-name": "\\u30D1\\u30B9 407",
    d: "M443.115,388.395l-1.141,30.72c-.448-.174-.89-.349-1.333-.536-1.1-.461-2.192-.941-3.264-1.458-.311-.143-.617-.293-.922-.442-1.035-.5-2.056-1.034-3.053-1.595q-1.8-1-3.545-2.1l6.049-26.995Z",
    transform: "translate(-396.086 -279.551)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_408",
    "data-name": "\\u30D1\\u30B9 408",
    d: "M550.832,409.83c-.162.112-.33.23-.5.349s-.355.249-.536.368q-1.57,1.084-3.2,2.075-2.3,1.4-4.7,2.635c-.049.025-.106.05-.156.075q-1.424.732-2.876,1.384h0l-1.14-30.826,6.89-2.293.318-.106Z",
    transform: "translate(-436.75 -278.608)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_93",
    "data-name": "\\u6955\\u5186\\u5F62 93",
    cx: 17.819,
    cy: 17.774,
    rx: 17.819,
    ry: 17.774,
    transform: "matrix(0.281, -0.96, 0.96, 0.281, 50.343, 83.559)",
    fill: "#e5b9a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_409",
    "data-name": "\\u30D1\\u30B9 409",
    d: "M494.647,353v15.768H477.378L480.711,353Z",
    transform: "translate(-414.002 -267.113)",
    fill: "#e5b9a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_410",
    "data-name": "\\u30D1\\u30B9 410",
    d: "M461.741,321.228v-6.935s-5.593-6.587.559-8.246c0,0,1.678-16.592,16.219-8.849,0,0,20.133-3.318,17.9,8.3,0,0,5.033-3.032,3.355,4.711l-3.245,12.472s1.567-8.239-3.466-9.345l-2.8-1.659s-7.83,7.743-19.574-1.659c0,0-5.033-1.2-4.474,3.776S461.741,321.228,461.741,321.228Z",
    transform: "translate(-407.229 -245.3)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_411",
    "data-name": "\\u30D1\\u30B9 411",
    d: "M463.759,418.365c-1.994-.417-3.956-.928-5.881-1.514l6.61-40.987,6.846-.212,12.417-.392,6.367-.2s4.517,19.849,7.962,42.333a70.863,70.863,0,0,1-9.875,1.981,71.975,71.975,0,0,1-8.573.586c-.237.006-.474.006-.71.006-1.564,0-3.121-.05-4.66-.15-1.346-.087-2.679-.206-4-.368-2.037-.243-4.049-.567-6.031-.991-.087-.012-.174-.031-.262-.05C463.9,418.4,463.828,418.377,463.759,418.365Z",
    transform: "translate(-406.65 -275.43)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_412",
    "data-name": "\\u30D1\\u30B9 412",
    d: "M457.33,418.217c-.087-.012-.174-.031-.262-.05-.069-.012-.143-.031-.212-.044-1.994-.417-3.956-.928-5.881-1.514q-2.719-.822-5.339-1.857c-.449-.174-.891-.349-1.334-.536-1.1-.461-2.192-.941-3.264-1.458-.311-.143-.617-.293-.922-.442l-.548-30.689,16.821-7.208s.056.449,8.042.991C465.951,380.37,457.33,418.217,457.33,418.217Z",
    transform: "translate(-399.747 -275.189)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_413",
    "data-name": "\\u30D1\\u30B9 413",
    d: "M527.4,379.208l-3.171,16.665.3,15.07q-1.382.71-2.79,1.346l-.087.037c-.218.1-.449.206-.673.3-1.738.773-3.514,1.477-5.32,2.1q-2.308.813-4.685,1.458a70.865,70.865,0,0,1-9.875,1.981,71.979,71.979,0,0,1-8.572.586l-.33-26.708c-.7-8.61,1.614-14.3,4.448-17.992,15.108-2.018,14.771-2.2,14.771-2.2l16.017,7.208Z",
    transform: "translate(-419.539 -274.22)",
    fill: "#2f2e41"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_768",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 768",
    transform: "translate(877.594 124.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_414",
    "data-name": "\\u30D1\\u30B9 414",
    d: "M1614.1,381.576a72.175,72.175,0,0,1-30.957,59.3c-.174.125-.354.249-.536.368q-1.57,1.084-3.2,2.075-2.3,1.4-4.7,2.635c-.972.5-1.95.972-2.946,1.42-.25.112-.5.231-.761.336-1.738.773-3.514,1.476-5.32,2.1a71.163,71.163,0,0,1-14.559,3.439,72.371,72.371,0,0,1-9.283.592c-1.563,0-3.12-.05-4.66-.15-1.346-.087-2.678-.206-4-.368-2.125-.255-4.224-.6-6.292-1.04-.068-.012-.143-.031-.211-.044a70.625,70.625,0,0,1-12.554-3.906c-1.1-.461-2.192-.941-3.265-1.458q-2.028-.953-3.975-2.037A72.274,72.274,0,1,1,1614.1,381.576Z",
    transform: "translate(-1469.537 -309.294)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_94",
    "data-name": "\\u6955\\u5186\\u5F62 94",
    cx: 16.138,
    cy: 16.138,
    r: 16.138,
    transform: "translate(54.169 57.817)",
    fill: "#ffd3bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_415",
    "data-name": "\\u30D1\\u30B9 415",
    d: "M1555.375,419.22s1.371-2.408,1.052-10.452,11.93-3.494,22.166-4.261,8.068,13.429,8.068,13.429.738-.844,2.319-7.7-2.009-13.68-2.009-13.68c-1.057-7.2-6.754-4.892-6.754-4.892,2.744,1.068,2.217,3.352,2.217,3.352-2.323-4.073-8.02-1.765-8.02-1.765-7.6-4.768-15.3,1.511-15.3,1.511-9.18,2.083-3.8,9.384-3.8,9.384C1546.086,408.815,1555.375,419.22,1555.375,419.22Z",
    transform: "translate(-1500.335 -340.216)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_416",
    "data-name": "\\u30D1\\u30B9 416",
    d: "M1583.872,448v10.391h-10.127l.628-10.391Z",
    transform: "translate(-1508.823 -361.586)",
    fill: "#ffd3bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_417",
    "data-name": "\\u30D1\\u30B9 417",
    d: "M1567.867,510.39c-2.125-.255-4.224-.6-6.292-1.04l1.963-44.158.28-.293,4.018-4.243h12.778l4.716,4.567.4.392,10.086,9.663,4.554,31.6a71.164,71.164,0,0,1-14.56,3.439,72.386,72.386,0,0,1-9.283.592c-1.563,0-3.12-.05-4.66-.149C1570.521,510.67,1569.189,510.552,1567.867,510.39Z",
    transform: "translate(-1504.235 -366.358)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_418",
    "data-name": "\\u30D1\\u30B9 418",
    d: "M1533.308,506.381q-2.028-.953-3.975-2.037c-.131-11.962-.218-19.9-.218-19.9l1.52-.928a.445.445,0,0,1,.056-.025l17.251-10.479,3.62-5.881.019.212,1.065,12.4a215.969,215.969,0,0,1,6.984,33.461c-1.346-.087-2.678-.206-4-.368-2.125-.255-4.225-.6-6.293-1.04-.068-.012-.143-.031-.211-.044a70.614,70.614,0,0,1-12.554-3.906C1535.47,507.378,1534.38,506.9,1533.308,506.381Z",
    transform: "translate(-1491.998 -368.797)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_419",
    "data-name": "\\u30D1\\u30B9 419",
    d: "M1614.12,509.316a71.158,71.158,0,0,1-14.56,3.439,56.886,56.886,0,0,1-.754-12.18c1.346-21.512-1.757-33.449-.411-33.449l.685.536,8.467,6.691,11.146,4.087h.006l7.669,2.81,1.352.5v.642c.006,2.218.019,9.98.131,20.434q-2.3,1.4-4.7,2.635c-.972.5-1.95.972-2.946,1.42-.25.112-.5.231-.761.336C1617.7,507.989,1615.927,508.693,1614.12,509.316Z",
    transform: "translate(-1517.986 -368.797)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_420",
    "data-name": "\\u30D1\\u30B9 420",
    d: "M1516.9,509.223c.237-5.476.343-9.009.218-9.5-.642-2.567,8.118-6.006,8.915-6.311a.45.45,0,0,1,.056-.025l1.782.953.835,21.942q-2.028-.953-3.975-2.037A71.705,71.705,0,0,1,1516.9,509.223Z",
    transform: "translate(-1487.391 -378.697)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_421",
    "data-name": "\\u30D1\\u30B9 421",
    d: "M1639.1,509.61q-2.3,1.4-4.7,2.635c-.972.5-1.95.972-2.946,1.42-.25.112-.5.231-.761.336l-2.8-27.68,1.639-1.2s.15.037.417.1h.006a32.414,32.414,0,0,1,7.669,2.81,4.787,4.787,0,0,1,1.352,1.14,1.383,1.383,0,0,1,.318.984c-.074.723,1.172,7.576,3.015,17.375Q1640.731,508.619,1639.1,509.61Z",
    transform: "translate(-1529.234 -375.583)",
    fill: "#2f2e41"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_772",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 772",
    transform: "translate(1000.614 385.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_771",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 771",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_770",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 770",
    transform: "translate(-14.362 -15.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_422",
    "data-name": "\\u30D1\\u30B9 422",
    d: "M1788.171,776.416a72.017,72.017,0,0,1-30.389,58.033c-.161.111-.329.23-.5.348s-.354.249-.535.366q-1.567,1.082-3.2,2.07-2.294,1.4-4.694,2.63l-.156.075q-1.379.708-2.784,1.343c-.032.013-.057.025-.087.037-.218.1-.448.2-.672.3-1.734.771-3.506,1.473-5.309,2.1q-2.3.811-4.674,1.455a70.734,70.734,0,0,1-9.853,1.977,71.809,71.809,0,0,1-8.554.584c-.237.006-.473.006-.709.006-1.56,0-3.115-.05-4.65-.15-1.343-.087-2.673-.2-3.991-.366-2.033-.243-4.041-.566-6.017-.989-.087-.012-.174-.031-.261-.05-.069-.013-.143-.031-.211-.044-1.99-.416-3.948-.926-5.869-1.51q-2.714-.821-5.328-1.853c-.447-.174-.888-.348-1.33-.535-1.1-.46-2.188-.939-3.258-1.455-.311-.143-.615-.292-.92-.441-1.032-.5-2.051-1.032-3.046-1.592q-1.8-1-3.537-2.1c-1.461-.92-2.891-1.89-4.277-2.916a72.114,72.114,0,1,1,114.8-57.324Z",
    transform: "translate(-1643.946 -703.509)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_769",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 769",
    transform: "translate(26.256 52.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_423",
    "data-name": "\\u30D1\\u30B9 423",
    d: "M1747.565,787.3a4.147,4.147,0,0,0-2.3.49,5.744,5.744,0,0,0-1.559,1.955,23.835,23.835,0,0,1-6.706,7.2c-1.993,1.387-4.526,3.116-4.185,5.673a7.45,7.45,0,0,0,.971,2.395c1.839,3.526,6.855,6.251,6.361,10.273,1.826-2.9-.617-4.341,1.209-7.246.87-1.383,2.381-2.945,3.694-2.077.44.291.729.813,1.186,1.069,1.093.609,2.255-.556,3.222-1.381,3.334-2.843,8.077-2.1,12.226-1.212,1.959.418,4.11.967,5.268,2.746,1.523,2.339-1.447,4.865-2.2,7.509a1.437,1.437,0,0,0,1.089,1.756,1.6,1.6,0,0,0,.539.037c1.245-.117,2.719-.212,2.793-.731,1.566.053,3.486-.115,4.157-1.665a6.219,6.219,0,0,0,.321-1.9c.247-2.6,1.409-4.978,2.18-7.455s1.105-5.381-.2-7.578a8.887,8.887,0,0,0-1.7-1.967C1766.555,788.411,1756.855,787.292,1747.565,787.3Z",
    transform: "translate(-1703.692 -787.29)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_424",
    "data-name": "\\u30D1\\u30B9 424",
    d: "M1743.553,838.919s1.6,12.7-4.279,13.72,5.348,18.293,5.348,18.293l26.74,3.049-6.417-20.325s-4.279-1.524-1.6-11.687S1743.553,838.919,1743.553,838.919Z",
    transform: "translate(-1705.498 -805.841)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_95",
    "data-name": "\\u6955\\u5186\\u5F62 95",
    cx: 16.044,
    cy: 15.244,
    rx: 16.044,
    ry: 15.244,
    transform: "translate(34.044 10.974)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_425",
    "data-name": "\\u30D1\\u30B9 425",
    d: "M1722.162,894.815c2.837-10.6,6.755-24.879,6.755-24.879s1.524.3,3.924.63a97.737,97.737,0,0,0,10.581.913c4.534.12,9.307-.164,13-1.379a12.413,12.413,0,0,0,3.838-1.946,7.2,7.2,0,0,0,1.286-1.267c6.417-8.131,9.089,22.864,9.089,22.864l.5,5.064Z",
    transform: "translate(-1699.689 -816.785)",
    fill: "#224ea8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_426",
    "data-name": "\\u30D1\\u30B9 426",
    d: "M1750.484,793.706a3.812,3.812,0,0,0-1.876.346,4.235,4.235,0,0,0-1.269,1.382,18.089,18.089,0,0,1-5.459,5.087c-1.622.98-3.684,2.2-3.407,4.01a4.9,4.9,0,0,0,.791,1.693,12.756,12.756,0,0,1,1.7,8.3l4.461-6.16c.708-.978,1.938-2.082,3.006-1.468.358.206.593.574.966.755.889.431,1.835-.392,2.622-.976,2.714-2.01,6.575-1.483,9.952-.857,1.594.3,3.345.683,4.289,1.941,1.567,2.09-.07,5.109.845,7.522a2.206,2.206,0,0,0,.966-1.464c1.275.037,2.838-.082,3.384-1.177a3.884,3.884,0,0,0,.262-1.339c.2-1.84,1.147-3.518,1.774-5.269s.9-3.8-.159-5.356a6.632,6.632,0,0,0-1.386-1.39C1765.942,794.49,1758.046,793.7,1750.484,793.706Z",
    transform: "translate(-1705.829 -789.705)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_427",
    "data-name": "\\u30D1\\u30B9 427",
    d: "M1729.226,866.464a34.868,34.868,0,0,1-5.933-10.027v-.006s-5.833-3.174-7.438-.126-16.58,10.669-18.184,10.669a.21.21,0,0,1-.04.013c-.636.2-8.6,2.954-10.653,13.2a72.909,72.909,0,0,0-.888,10.651H1729.7c.451-4.491.789-8.692.921-12.32.193-5.057.007-8.988-.8-11.016A3.173,3.173,0,0,0,1729.226,866.464Z",
    transform: "translate(-1686.09 -812.81)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_428",
    "data-name": "\\u30D1\\u30B9 428",
    d: "M1800.922,870.8c-.027-.12-.047-.22-.067-.315a2.279,2.279,0,0,0-.358-.756.054.054,0,0,1-.006-.019c-3.09-4.547-22.957-10.808-22.957-10.808l-.743,2.437s.093,2.406.226,6.261c.133,3.609.292,8.484.444,13.838.106,3.5.2,7.2.285,10.878h29.718A158.69,158.69,0,0,0,1800.922,870.8Z",
    transform: "translate(-1720.284 -814.289)",
    fill: "#2f2e41"
  })))))), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_96",
    "data-name": "\\u6955\\u5186\\u5F62 96",
    cx: 41.43,
    cy: 41.43,
    r: 41.43,
    transform: "translate(434.306)",
    fill: "#f1f1f1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_97",
    "data-name": "\\u6955\\u5186\\u5F62 97",
    cx: 41.43,
    cy: 41.43,
    r: 41.43,
    transform: "translate(172.023 664.119)",
    fill: "#f1f1f1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_98",
    "data-name": "\\u6955\\u5186\\u5F62 98",
    cx: 41.43,
    cy: 41.43,
    r: 41.43,
    transform: "translate(828.666 666.611)",
    fill: "#f1f1f1"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_776",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 776",
    transform: "translate(0 400.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_775",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 775",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_774",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 774",
    transform: "translate(-16.846 -21.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_430",
    "data-name": "\\u30D1\\u30B9 430",
    d: "M189.69,794.983a77.806,77.806,0,0,1-33.372,63.93,76.876,76.876,0,0,1-9.1,5.474c-1.048.538-2.1,1.048-3.177,1.531-.968.443-1.941.86-2.928,1.256a78.186,78.186,0,0,1-38.665,5.158q-3.405-.4-6.723-1.108l-.289-.061A76.132,76.132,0,0,1,81.9,866.952,77.915,77.915,0,1,1,189.69,794.983Z",
    transform: "translate(-33.839 -717.056)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_773",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 773",
    transform: "translate(43.834 53.298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_99",
    "data-name": "\\u6955\\u5186\\u5F62 99",
    cx: 23.211,
    cy: 24.639,
    rx: 23.211,
    ry: 24.639,
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_100",
    "data-name": "\\u6955\\u5186\\u5F62 100",
    cx: 12.211,
    cy: 12.211,
    r: 12.211,
    transform: "translate(31.595 37.504)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_431",
    "data-name": "\\u30D1\\u30B9 431",
    d: "M150.833,856.155l6.541,17.007L140.8,880.141l-1.455-3.3-5.087-11.529Z",
    transform: "translate(-115.532 -822.794)",
    fill: "#f9d1bd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_101",
    "data-name": "\\u6955\\u5186\\u5F62 101",
    cx: 14.609,
    cy: 14.609,
    r: 14.609,
    transform: "translate(7.61 15.263)",
    fill: "#f9d1bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_432",
    "data-name": "\\u30D1\\u30B9 432",
    d: "M118.2,835.529c9.182-6.127,11.927-7.592,22.452-5.225l.631-15.355-27.2,5.706Z",
    transform: "translate(-107.927 -807.259)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_433",
    "data-name": "\\u30D1\\u30B9 433",
    d: "M175.571,894.191l-.4.047a.259.259,0,0,0-.034-.04c-1.6-1.6-9.228-4.507-14.916-6.522h-.007c-3.613-1.283-6.441-2.2-6.441-2.2l-6.877-7.072c-1.733,1.948-5.393,3.452-8.872,4.513a69.677,69.677,0,0,1-8.113,1.934H129.9l-1.424,4.547s-16.139,12.216-17.442,13.519h-.007v.014a.71.71,0,0,0-.121.51v.034a59.262,59.262,0,0,0-1.249,11.854h70.277V911.2C179.936,905.535,175.571,894.191,175.571,894.191Z",
    transform: "translate(-106.257 -831.181)",
    fill: "#575a89"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainvisual);
export default __webpack_public_path__ + "static/media/mainvisual.c86aba177bee813473ce3511890bd45a.svg";
export { ForwardRef as ReactComponent };